import { createApp } from "vue";
import router from "./router/index";
import store from "./store/store";
import App from "./App.vue";
import SoftUIDashboard from "./medical-hospital";
import VueTilt from "vue-tilt.js";
import VueSweetalert2 from "vue-sweetalert2";

// Element UI
import ElementPlus from 'element-plus'
import "element-plus/dist/index.css";
// Vue Cookies
import VueCookies from "vue-cookies";

import print from 'vue3-print-nb'

import '@fortawesome/fontawesome-free/css/all.css';
import '../src/assets/css/custom.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap-icons/font/bootstrap-icons.css';

// Import local functions
import { LoadUser, GetSession } from "./project/Source/localstate";
import { login } from "./project/Source/helper";

router.beforeEach(async (to, from, next) => {
  const currentRoute = to.matched[to.matched.length - 1];

  if (currentRoute.meta.requiresAuth) {
    if (!currentRoute.meta.role) {
      return next();
    }

    if (!GetSession()) {
      window.location.replace(login);
      return;
    }

    const user = store.state.user;
    if (!user) {
      return next({ path: "/session/LOGOUT" });
    }

    if (!user.roles) {
      try {
        const updatedUser = await LoadUser();
        if (!updatedUser) {
          return next({ path: "/session" });
        }
        const roleints = currentRoute.meta.role.filter(value => updatedUser.roles.includes(value));
        if (roleints.length > 0 || currentRoute.meta.role.includes("ANY")) {
          return next();
        } else {
          return next({ path: "/accessdenied" });
        }
      } catch (error) {
        return next({ path: "/session" });
      }
    }

    const roleints = currentRoute.meta.role.filter(value => user.roles.includes(value));
    if (roleints.length > 0 || currentRoute.meta.role.includes("ANY")) {
      return next();
    } else {
      return next({ path: "/accessdenied" });
    }
  } else {
    return next();
  }
});



// Create Vue App
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(VueCookies);
app.use(print);
app.use(SoftUIDashboard);
app.use(VueTilt);
app.use(VueSweetalert2);


store.commit("initialiseStore");

app.directive("upper", {
  beforeMount(el, binding, vnode) {
    el.addEventListener("input", (e) => {
      let letters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      let string = e.target.value.replace(/(([iışğüçö]))+/g, (letter) => letters[letter]);
      vnode.emit("update:modelValue", string.toUpperCase());
    });
  },
});

app.directive("decimal", {
  beforeMount(el) {
    let inputElement = el.querySelector("input");
    if (inputElement) {
      inputElement.addEventListener("input", () => {
        let regex = /^[0-9]*[.,]?[0-9]{0,2}$/;
        if (!regex.test(inputElement.value)) {
          inputElement.value = inputElement.value.slice(0, -1);
          inputElement.dispatchEvent(new Event("input"));
        }
      });
    }
  },
});

app.directive("lower", {
  beforeMount(el, binding, vnode) {
    el.addEventListener("input", (e) => {
      let letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ç": "ç", "Ö": "ö" };
      let string = e.target.value.replace(/(([İIŞĞÜÇÖ]))+/g, (letter) => letters[letter]);
      vnode.emit("update:modelValue", string.toLowerCase());
    });
  },
});

app.directive("letter", {
  beforeMount(el, binding, vnode) {
    el.addEventListener("input", (e) => {
      let newValue = e.target.value.replace(/[^ƏÜĞÖİIÇŞA-Z ]/g, "");
      vnode.emit("update:modelValue", newValue);
    });
  },
});



app.mount("#app");
